import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
         AlertDialogDescription, AlertDialogFooter, AlertDialogHeader,
         AlertDialogTitle } from "@/components/ui/alert-dialog";

/**
 * Final confirm gate for both "Send now" and "Schedule" flows. Copy adapts
 * to whichever mode is active so the admin doesn't accidentally schedule
 * when they meant to fire.
 */
export function ConfirmDialog({ open, onOpenChange, scheduleOn, preview,
                                 scheduleAt, onConfirm }) {
  const recipientCount = preview?.recipient_count ?? 0;
  const cost = preview?.estimated_cost_usd?.toFixed(2) ?? "0.00";
  const scheduledLabel = scheduleAt instanceof Date
    ? scheduleAt.toLocaleString()
    : new Date(scheduleAt).toLocaleString();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="sms-broadcast-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {scheduleOn ? "Schedule" : "Send"} SMS to {recipientCount} recipient{recipientCount === 1 ? "" : "s"}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            Estimated cost: <strong>${cost}</strong>.
            {scheduleOn
              ? ` This will queue delivery for ${scheduledLabel}. You can cancel any time before it fires.`
              : " This delivers immediately via your GoHighLevel account. Once sent it cannot be recalled."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="sms-broadcast-confirm-cancel">Not yet</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}
                             data-testid="sms-broadcast-confirm-yes"
                             className="bg-orange-500 hover:bg-orange-600 text-black">
            {scheduleOn ? "Schedule now" : "Send now"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
